/* Calculator tour exit controls (2026-10-01).
   Shared add-on for the per-section "Take a tour" cutout tours (#tourOverlay / #tourCutout / #tourTooltip).
   On every step it adds a close X (aria-label "Close tour") and a "Skip tour" link, and a pointer click on the
   dimmed backdrop closes the tour. Esc is already handled by each tour. Closing always goes through the
   section's own NS.endTour(), and each section's startTour() resets to step 1. */
(function () {
  if (window.__calcTourExit) return;
  window.__calcTourExit = 1;
  // floating site controls that sit above the dimmed backdrop: clicks on these are never treated as a backdrop click
  var BYPASS = '.scroll_top, .ccz-pill, [class*="back-to-top"], [class*="scroll-to-top"]';
  var CSS = '#tourTooltip{scroll-margin-top:90px;scroll-margin-bottom:16px}#tourTooltip .tour-step-label,#tourTooltip .tour-title{padding-right:30px}' +
    '#tourTooltip button.tour-close{position:absolute;top:6px;right:6px;width:32px;height:32px;min-width:32px;min-height:32px;display:inline-flex;align-items:center;justify-content:center;margin:0;padding:0;border:0;border-radius:50%;background:transparent;color:#050338;box-shadow:none;cursor:pointer;line-height:1;transition:background .12s,color .12s;z-index:1}' +
    '#tourTooltip button.tour-close:hover{background:rgba(204,49,129,.1);color:#CC3181}' +
    '#tourTooltip button.tour-close svg{display:block;width:14px;height:14px;pointer-events:none}' +
    '#tourTooltip button.tour-skip{display:inline-flex;align-items:center;width:auto;height:auto;min-height:32px;margin:6px 0 -8px -4px;padding:0 4px;border:0;border-radius:6px;background:none;color:#050338;box-shadow:none;font-size:.74rem;font-weight:600;letter-spacing:normal;text-transform:none;text-decoration:underline;text-underline-offset:2px;cursor:pointer;font-family:inherit;line-height:1.2}' +
    '#tourTooltip button.tour-skip:hover{color:#CC3181}' +
    '#tourTooltip button:focus-visible{outline:2px solid #CC3181;outline-offset:2px}' +
    '@media print{#tourTooltip .tour-close,#tourTooltip .tour-skip{display:none!important}}';

  function $(id) { return document.getElementById(id); }
  // the section's tour namespace, read from the Next button: onclick="FIRE.tourNext()"
  function ns() {
    var n = $('tourNext');
    var m = n && /([A-Za-z_$][\w$]*)\s*\.\s*tourNext\s*\(/.exec(n.getAttribute('onclick') || '');
    return m ? window[m[1]] : null;
  }
  function isOpen() { var o = $('tourOverlay'); return !!o && window.getComputedStyle(o).display !== 'none'; }
  function closeTour() {
    var N = ns();
    if (N && typeof N.endTour === 'function') N.endTour();
    else { var o = $('tourOverlay'); if (o) { o.classList.remove('active'); o.classList.remove('open'); } }
  }
  function onBackdrop(e) {
    if (!isOpen()) return false;
    var t = e.target;
    if (t && t.closest && (t.closest('#tourTooltip') || t.closest(BYPASS))) return false;
    var c = $('tourCutout'); if (!c) return true;
    var r = c.getBoundingClientRect();
    return !(e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom);
  }
  function setPx(el, prop, v) { v = Math.round(v) + 'px'; if (el.style[prop] !== v) el.style[prop] = v; }
  // keep the tooltip (and its X / Skip) usable on every step:
  // - a side-anchored step with no room beside the highlight (phones) would put it off screen: show it under the highlight
  // - a tooltip that opens above its highlight must not cover it (the Skip row makes it a little taller)
  // - it never starts above the top of the calculator
  var revealTimer;
  function nudge() {
    if (!isOpen()) return;
    var tt = $('tourTooltip'), c = $('tourCutout'), ov = $('tourOverlay');
    var tTop = parseFloat(tt.style.top), tLeft = parseFloat(tt.style.left);
    var cTop = parseFloat(c.style.top), cLeft = parseFloat(c.style.left), cH = parseFloat(c.style.height);
    if (isNaN(tTop) || isNaN(cTop) || isNaN(cH)) return;
    var h = tt.offsetHeight, w = tt.offsetWidth, W = ov.clientWidth;
    var nt = tTop;
    if (!isNaN(tLeft) && W && (tLeft < 0 || tLeft + w > W)) {
      setPx(tt, 'left', Math.max(4, Math.min(isNaN(cLeft) ? 4 : cLeft, W - w - 4)));
      nt = cTop + cH + 12;
    } else if (tTop < cTop && tTop + h > cTop - 6) {
      var up = cTop - h - 10;
      nt = up >= 4 ? up : cTop + cH + 12;
    }
    // never above the top of the calculator (it would sit under the fixed site header with its X hidden)
    setPx(tt, 'top', Math.max(4, nt));
    clearTimeout(revealTimer); revealTimer = setTimeout(reveal, 700);
  }
  // if the tooltip ended up out of view (or under the fixed site header), scroll just enough to show it
  function reveal() {
    if (!isOpen()) return;
    var tt = $('tourTooltip'), r = tt.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight) { try { tt.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { tt.scrollIntoView(false); } }
  }
  function init() {
    var tt = $('tourTooltip'), ov = $('tourOverlay');
    if (!tt || !ov || $('tourClose')) return;
    var st = document.createElement('style'); st.id = 'calc-tour-exit-css'; st.textContent = CSS;
    document.head.appendChild(st);

    var x = document.createElement('button');
    x.type = 'button'; x.className = 'tour-close'; x.id = 'tourClose';
    x.setAttribute('aria-label', 'Close tour'); x.title = 'Close tour';
    x.innerHTML = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M2 2l10 10M12 2L2 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    x.addEventListener('click', closeTour);
    tt.insertBefore(x, tt.firstChild);

    var s = document.createElement('button');
    s.type = 'button'; s.className = 'tour-skip'; s.id = 'tourSkip'; s.textContent = 'Skip tour';
    s.addEventListener('click', closeTour);
    var ctr = tt.querySelector('.tour-controls');
    if (ctr && ctr.parentNode === tt) tt.insertBefore(s, ctr.nextSibling); else tt.appendChild(s);

    if (!tt.getAttribute('role')) {
      tt.setAttribute('role', 'dialog');
      if ($('tourTitle')) tt.setAttribute('aria-labelledby', 'tourTitle');
      if ($('tourBody')) tt.setAttribute('aria-describedby', 'tourBody');
    }

    // after any exit (X, Skip, Done, Esc, backdrop): don't leave keyboard focus on the hidden tooltip
    var wasOpen = isOpen();
    new MutationObserver(function () {
      var open = isOpen();
      if (wasOpen && !open) {
        var a = document.activeElement;
        if (!a || a === document.body || ov.contains(a)) {
          var app = ov.closest('.calculator-app') || document;
          var trig = app.querySelector('.tour-trigger');
          if (trig) { try { trig.focus({ preventScroll: true }); } catch (e) {} }
        }
      }
      wasOpen = open;
    }).observe(ov, { attributes: true, attributeFilter: ['class', 'style'] });
    new MutationObserver(nudge).observe(tt, { attributes: true, attributeFilter: ['style'] });

    // touch / pen: close on a tap (pointerdown + pointerup without moving) so it also works over controls that
    // never fire a click on touch, such as range sliders; a drag that scrolls the page is a pointercancel and is ignored
    var down = null, swallowUntil = 0;
    function noSlider(e) { if (down && e.target && e.target.closest && e.target.closest('input[type="range"]')) e.preventDefault(); }
    document.addEventListener('pointerdown', function (e) {
      down = null;
      if (e.pointerType === 'mouse' || !onBackdrop(e)) return;
      down = { id: e.pointerId, x: e.clientX, y: e.clientY };
    }, true);
    document.addEventListener('pointercancel', function () { down = null; }, true);
    document.addEventListener('pointerup', function (e) {
      var d = down; down = null;
      if (!d || e.pointerId !== d.id || Math.abs(e.clientX - d.x) > 10 || Math.abs(e.clientY - d.y) > 10 || !isOpen()) return;
      swallowUntil = Date.now() + 800; // the tap's follow-up mousedown/click must not act on the page underneath
      closeTour();
    }, true);
    document.addEventListener('mousedown', function (e) { if (Date.now() < swallowUntil || onBackdrop(e)) e.preventDefault(); }, true);
    document.addEventListener('click', function (e) {
      if (Date.now() < swallowUntil) { swallowUntil = 0; e.preventDefault(); e.stopPropagation(); return; }
      if (e.detail === 0 || !onBackdrop(e)) return; // detail 0 = keyboard-activated click, not a backdrop click
      e.preventDefault(); e.stopPropagation();
      closeTour();
    }, true);
    // only while the tour is open: stop a backdrop tap from moving a slider underneath (non-passive, so not kept on all the time)
    function sliderGuard(on) {
      if (on) document.addEventListener('touchstart', noSlider, { capture: true, passive: false });
      else document.removeEventListener('touchstart', noSlider, { capture: true, passive: false });
    }
    sliderGuard(wasOpen);
    new MutationObserver(function () { sliderGuard(isOpen()); }).observe(ov, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
